<template>

  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        v-if="errorMsg"
        no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-alert
              v-if="errorMsg"
              variant="warning"
              class="w-100"
              show
            >
              <div class="alert-body">
                <span>{{ errorMsg }}</span>
              </div>
            </b-alert>
          </b-row>
        </div>
      </b-card>
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="invoicesList"
          responsive
          :fields="tableFields"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
          selectable
          @row-selected="onRowSelected"
        >
          <template #cell(id)="data">
            <b-link
              target="_blank"
              :to="{ name: 'invoice-details', params: { id: data.item.id } }"
            />
          </template>
          <template #cell(invoice_bc_id)="data">
            <b-badge
              :variant="data.item.bc_approved ? 'light-success' : 'light-warning'"
            >
              {{ data.item.invoice_bc_id }}
            </b-badge>
          </template>
          <template
            #cell(invoice_date)="data"
          >
            {{ formattedDate(data.item.invoice_date) }}
          </template>
          <template
            #cell(due_date)="data"
          >
            {{ formattedDate(data.item.due_date) }}
          </template>
          <template
            #cell(total)="data"
          >
            {{ formatCurrency(data.item.total, defaultCurrency) }}
          </template>
          <template #cell(paid)="data">
            <b-link
              class="font-weight-bold d-block text-nowrap"
              :href="getLink(data.item.case_id)"
              target="_blank"
            >
              <b-badge
                :variant="data.item.paid ? 'light-success' : 'light-danger'"
              >
                {{
                  !data.item.bc_approved ? 'Not Approved'
                  : data.item.paid ? 'Paid'
                    : data.item.case_id ? 'Case Runnig ' + data.item.case_id : 'Unpaid'
                }}
              </b-badge>
            </b-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOW') }} {{ from }} {{ $t('DEBTIA_TO') }} {{ to }} {{ $t('DEBTIA_OF') }} {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BTable, BPagination, BOverlay, BBadge, BAlert, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import constants from '@/app-configs/constants'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BBadge,
    vSelect,
    BOverlay,
    BAlert,
    BLink,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      errorMsg: null,
      loader: false,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      invoicesList: [],
      entries: [],
      defaultCurrency: localStorage.getItem('defaultCurrency') || 'DKK',
      constants,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'client_bc_id', sortable: true, label: i18n.t('CLIENT_BC_ID') },
        { key: 'client_name', sortable: true, label: i18n.t('CLIENT_NAME') },
        { key: 'invoice_bc_id', sortable: true, label: i18n.t('INVOICE_BC_ID') },
        { key: 'invoice_date', sortable: true, label: i18n.t('DEBTIA_INVOICE_DATE') },
        { key: 'due_date', sortable: true, label: i18n.t('DEBTIA_DUE_DATE') },
        { key: 'total', sortable: true, label: i18n.t('DEBTIA_TOTAL') },
        { key: 'paid', sortable: true, label: i18n.t('DEBTIA_STATUS') },
      ]
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.getList()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getList()
      },
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getLink(caseId) {
      if (caseId != null) {
        return `${constants.CaseAppBaseUrl}/cases/details/v2/${caseId}`
      }
      return '#'
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    formattedDate(date) {
      if (!date) return 'Invalid date' // Return an empty string if date is not provided
      // Convert the date to a string if it's not already one
      const dateString = String(date)
      // Check if the date string is in the correct format (YYYY-MM-DD)
      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-')
        return `${day}-${month}-${year}`
      }
      // Handle invalid date format or other cases
      return 'Invalid date'
    },
    onRowSelected(item) {
      this.selected = item
      this.$router.push(`/invoice/details/${item['0'].id}`)
    },
    async getList() {
      this.loader = true
      const list = await axios.get(`/invoice-system/invoices?per_page=${this.perPage}&page=${this.currentPage}`)
      // this.loader = false
      if (list.status) {
        this.invoicesList = list.data.data.data
        this.totalPages = list.data.data.total
        this.from = list.data.data.from
        this.to = list.data.data.to
        this.currentPage = list.data.data.current_page
        this.loader = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
